<template>
  <section>
    <NavBar id="navbar" />
    <NavBarSecond
      :pageType="'components.secondNavBar.client' | i18n"
      backRoute="/admin"
    />
    <b-row id="client-main" class="mx-auto py-4" no-gutters>
      <b-col cols="12" lg="4">
        <div id="client-logo" class="bg-primary shadow-sm rounded p-5 mb-4">
          <h3 v-if="clientInfo != null" class="text-white mb-0">
            {{ clientInfo["client_nom"].value }}
          </h3>
        </div>
        <DetailsSection
          class="bg-white shadow-sm rounded p-5 mb-4"
          :objectId="$route.params.id"
          objectType="client"
          @onDataFetched="saveClientInformation"
        />
        <ChartNotificationsByClient
          class="bg-white shadow-sm rounded p-5 mb-4 position-relative"
          :clientId="+$route.params.id"
        />
      </b-col>
      <b-col cols="12" lg="8" class="pl-lg-4">
        <ListServersSection
          class="bg-white shadow-sm rounded p-5 mb-4"
          :clientId="+$route.params.id"
        />
        <ListSoftwaresByClientSection
          class="bg-white shadow-sm rounded p-5"
          :clientId="+$route.params.id"
          pageType="clientDetails"
        />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { NavBar, NavBarSecond, ChartNotificationsByClient } from "@/components";
import {
  DetailsSection,
  ListSoftwaresByClientSection,
  ListServersSection
} from "@/sections";
/**
 * @description Page de détail d'un client
 * @author Samuel Colassin
 * @vue-data {Object} clientInfo - Informations du client
 */
export default {
  components: {
    NavBar,
    DetailsSection,
    ChartNotificationsByClient,
    ListSoftwaresByClientSection,
    ListServersSection,
    NavBarSecond
  },
  name: "ClientDetails",
  data() {
    return {
      clientInfo: null
    };
  },
  methods: {
    /**
     * @description Sauvegarde les informations du client dans un data
     * @param {Object} clientInfo Les informations du client
     */
    saveClientInformation(clientInfo) {
      this.clientInfo = clientInfo.entries;
    }
  }
};
</script>

<style scoped lang="scss">
@media screen and (min-width: 1366px) {
  #client-main {
    width: 1366px;
  }
}
</style>
